import type { ReactNode } from "react";

/** Los iconos de la barra de herramientas de una hoja: lápiz, resaltador, borrador, deshacer, mano. */

function Icono({ children }: { children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export function IconoLapiz() {
  return (
    <Icono>
      <path d="M4 20l1-4L16 5l3 3L8 19l-4 1z" />
      <path d="M14 7l3 3" />
    </Icono>
  );
}

export function IconoResaltador() {
  return (
    <Icono>
      <path d="M9 15l-3 3h5l1-1" />
      <path d="M9 15l7-10 4 3-7 10-4-3z" />
      <path d="M4 21h16" strokeWidth="2.6" opacity=".45" />
    </Icono>
  );
}

export function IconoBorrador() {
  return (
    <Icono>
      <path d="M8 20h12" />
      <path d="M5 15l9-10 6 6-8 9H9l-4-5z" />
      <path d="M10 10l6 6" />
    </Icono>
  );
}

export function IconoDeshacer({ espejo = false }: { espejo?: boolean }) {
  return (
    <Icono>
      <g transform={espejo ? "matrix(-1 0 0 1 24 0)" : undefined}>
        <path d="M9 5L4 10l5 5" />
        <path d="M4 10h10a5 5 0 010 10h-3" />
      </g>
    </Icono>
  );
}

export function IconoDedo() {
  return (
    <Icono>
      <path d="M9 11V5a1.5 1.5 0 013 0v5" />
      <path d="M12 10V4a1.5 1.5 0 013 0v6" />
      <path d="M15 10V6a1.5 1.5 0 013 0v7c0 4-2.5 7-6 7s-5-2-6.5-4.5L4 12.5a1.5 1.5 0 012.5-1.6L9 14" />
    </Icono>
  );
}
